export default {
  LANDING_LOGIN: '/landing/login-token',
  LOGIN: '/login',
  PROFILE: '/profile',
  QUOTE: '/quote',
  POST_BIND: '/post-bind',
};
